import { useProfileDataStore } from '$layouts/UserProfileLayout/hooks/useProfileDataStore'
import {
  getUserStatusHistories,
  postUpdatePassword,
  postUpdateUserStatus
} from '$services/api'
import { useRequest } from 'ahooks'
import { toast } from 'sonner'

export const useUserService = () => {
  const updateProfilePartially = useProfileDataStore(
    state => state.updateProfilePartially
  )

  const { runAsync: updatePasswordAsync, loading: updatingPassword } =
    useRequest(postUpdatePassword, {
      manual: true,
      onSuccess: () => {
        toast.success('Password Updated Successfully!')
      }
    })

  const { runAsync: updateUserStatusAsync, loading: updatingUserStatus } =
    useRequest(postUpdateUserStatus, {
      manual: true,
      onSuccess: (_, [{ status }]) => {
        const isActive = status === 'active'
        const message = isActive
          ? 'User has been activated!'
          : 'User has been terminated!'
        toast.success(message)
        updateProfilePartially({ status })
      }
    })

  const {
    runAsync: fetchUserStatusHistories,
    loading: fetchingUserStatusHistories,
    data: userStatusHistoriesData
  } = useRequest(getUserStatusHistories, {
    manual: true
  })

  const { data: status_histories = [], meta } = { ...userStatusHistoriesData }

  return {
    updatePasswordAsync,
    updatingPassword,

    updateUserStatusAsync,
    updatingUserStatus,

    userStatusHistores: {
      data: {
        meta,
        status_histories
      },
      fetchUserStatusHistories,
      fetchingUserStatusHistories
    }
  }
}
